import { Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';

@Injectable()
export class PageTitleService extends Title {
  // the suffix to be used on all page titles
  suffix = ' - My Account';

  title(s: string): void {
    this.setTitle(s + this.suffix);
  }
}



// WEBPACK FOOTER //
// ./app/services/pagetitle/pagetitle.service.ts